export enum BoardTypes {
  PLAYER_BOARD = 'P',
  PAIR_PLAYER_BOARD = 'PP',
  BANKER_BOARD = 'B',
  PAIR_BANKER_BOARD = 'BP',
  TIE = 'T',
}
